import easasMainRouter from "components/pages/easas-main/routes";
import React from "react";
import { RouterProvider } from "react-router-dom";

const DashboardFragment = () => {
  return <RouterProvider router={easasMainRouter} future={{ v7_startTransition: true }} />;
};

export default DashboardFragment;
